import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=3af3e5e0"
import script from "./ColorCard.vue?vue&type=script&lang=ts"
export * from "./ColorCard.vue?vue&type=script&lang=ts"
import style0 from "./ColorCard.vue?vue&type=style&index=0&id=3af3e5e0&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports